export const validation = (e, columns, callback) => {
    if (typeof e === 'object') {
        for (const i in e) {
            columns.forEach((formValue) => {
                if (formValue.name === i) {
                    formValue.error = e[i];
                }
            })

            callback(columns);
        }
    }
}
